import "/tmp/tmp-3957-e74CiZb5eDpe/190c51fa729e/index.module.css";
export default {"container":"index-module__container___fTvZI","content":"index-module__content___HAHyF","contentBack":"index-module__contentBack___teSNT"};